import React, { useState } from "react";
import dayjs from "dayjs";
import "dayjs/locale/es";

import style from "../assets/css/components/Match.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPencilAlt,
  faShieldAlt,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";

import classNames from "classnames";
import Modal from "./Modal";
import FormAddMatch from "./Form/FormAddMatch";
import Swal from "sweetalert2";
import useDeleteMatch from "../hooks/useDeleteMatch";
import { Link } from "react-router-dom";

const modalStates = { editMatch: false };

dayjs.locale("es");

function Match({ match, admin, teamsOptions, tournament }) {
  const [activeModals, setActiveModals] = useState(modalStates);
  const [edit, setEdit] = useState(false);
  const { deleteMatch } = useDeleteMatch();

  const changeModalState = (modal) => async () => {
    setActiveModals({ ...activeModals, [modal]: !activeModals[modal] });
  };

  const handleDelete = () => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "Esta acción no se puede revertir",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "¡Sí, eliminalo!",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await deleteMatch(match?._id, {
          teamId: match?.homeTeam?._id,
          rivalTeamId: match?.visitingTeam?._id,
        });
        Swal.fire(response);
      }
    });
  };

  return (
    <>
      <div className={style.card} onClick={() => setEdit(!edit)}>
        <div className={style.cardHead}>
          <p className={style.league}>{tournament}</p>
          <p className={style.day}>
            {match.type !== "jornada" ? match.type : `j${match.day}`}
          </p>
        </div>
        <div
          className={
            edit ? classNames(style.contMatch, style.contEdit) : style.contMatch
          }
        >
          <div className={style.match}>
            <div className={style.contShield}>
              <p className={style.shield}>
                <FontAwesomeIcon
                  icon={faShieldAlt}
                  color={match?.local?.colorShirt}
                />
              </p>
              <p className={style.txt}>vs</p>
              <p className={style.shield}>
                <FontAwesomeIcon
                  icon={faShieldAlt}
                  color={match?.visit?.colorShirt}
                />
              </p>
            </div>
            <div className={style.nameTeams}>
              <div className={style.team}>
                <p className={style.points}>
                  {match?.local?.general_table?.pts} <span>pts</span>
                </p>
                <p className={style.name}>
                  {match?.local?.name[0].toUpperCase() +
                    match?.local?.name.slice(1)}
                </p>
              </div>
              <div className={style.team}>
                <p className={style.points}>
                  {match?.visit?.general_table?.pts} <span>pts</span>
                </p>
                <p className={style.name}>
                  {match?.visit?.name[0].toUpperCase() +
                    match?.visit?.name.slice(1)}
                </p>
              </div>
            </div>
            {match.StatusMatch !== "fin" ? (
              <div className={style.infoMatch}>
                <p className={style.time}>
                  {match?.hour
                    ? dayjs(match?.date + " " + match?.hour).format("HH:mm")
                    : "H/F"}
                </p>
                <p className={style.date}>
                  {match?.date
                    ? dayjs(match?.date).format("DD MMM YYYY")
                    : "Por definir"}
                </p>
              </div>
            ) : (
              <div className={style.score}>
                <p className={style.goal}>{match?.goalLocal}</p>
                {/* <p className={style.goal}>-</p> */}
                <p className={style.goal}>{match?.goalVisit}</p>
              </div>
            )}
          </div>
          <div className={style.contBtn}>
            {admin ? (
              <Link
                className={style.link}
                to={"/admin/livematch"}
                state={{ match: match?.id }}
              >
                LIVE
              </Link>
            ) : null}
            <div className={style.btnActions}>
              {(match?.stories?.length || admin) &&  (
                <Link
                  className={style.link}
                  to={"/storymatch"}
                  state={{ idMatch: match?.id }}
                >
                  MIN
                </Link>
              )}
              {admin ? (
                <>
                  <button
                    className={classNames(style.btn, style.btnEdit)}
                    onClick={changeModalState("editMatch")}
                  >
                    <FontAwesomeIcon icon={faPencilAlt} />
                  </button>
                  <button
                    className={classNames(style.btn, style.btnDelete)}
                    onClick={handleDelete}
                  >
                    <FontAwesomeIcon icon={faTrashAlt} />
                  </button>
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <Modal
        title="Editar partido"
        show={activeModals.editMatch}
        close={changeModalState("editMatch")}
      >
        <div className={style.modalMatch}>
          <FormAddMatch options={teamsOptions} />
        </div>
      </Modal>
    </>
  );
}

export default Match;
